const tempVal = {
    yOffset: 0,
}  

export default tempVal;